export default {
  apply_socialPitch:
    "Aidez-nous à avoir un aperçu de qui vous êtes en dehors des limites d'un CV ou d'une lettre de motivation",
  apply_submit: 'Soumettre la candidature',
  apply_submitting: 'Soumission en cours...',
  apply_cv_label: 'CV',
  apply_coverLetter_label: 'Lettre de motivation',
  apply_email_label: 'Courriel',
  apply_name_label: 'Nom complet',
  apply_sex_label: 'Genre',
  apply_ssn_label: 'SSN',
  apply_phone_label: 'Numéro de téléphone',
  apply_successModal_title: 'Candidature reçue',
  apply_successModal_text:
    'Une confirmation a été envoyée à votre adresse e-mail. Si vous ne recevez pas le message de confirmation dans quelques minutes, veuillez vérifier votre dossier Spam.',
  apply_successModal_backToJobs: 'Retour vers le site',
  apply_error_required: 'Ce champ est requis',
  apply_error_email: 'Adresse e-mail invalide',
  apply_error_ssn: 'SSN invalide',
  apply_connect: 'Connecter avec',
  apply_connected: 'connecté',

  backToJobs: 'Retour vers les postes',
  backToDetail: 'Retour à la description du poste',
  openings_singular: '{0} Poste ouvert',
  openings_plural: '{0} Postes ouverts',
  no_openings: 'Aucun poste ouvert actuellement',
  apply_button: 'Postuler maintenant',
  deadline_display: 'Date limite',
  vacancies_singular: 'poste ouvert',
  vacancies_plural: 'postes ouverts',
  filter_search_placeholder: 'Rechercher',
  accept_terms_body_text: 'Cochez ici pour indiquer que vous avez lu et accepté les termes de la',
  fifty_privacy_policy: ' politique de confidentialité de 50skills',
  privacy_policy_and: 'et',
  company_privacy_policy: ' politique de confidentialité de {0}',
  terms_agreement_required: "L'acceptation des termes est requis.",
  apply_form_has_errors: 'Le formulaire ci-dessus contient des erreurs.',
  job_list_no_openings_main: 'Aucun poste ouvert pour le moment',
  job_list_no_openings_sub: 'Veuillez vérifier plus tard!',
  job_list_no_language_data: "Ce poste n'a actuellement pas de traduction française",
  job_list_no_language_data_sub:
    "Pour voir le poste dans d'autres langues, changez de langue en haut à droite.",
  jobStatus_full_time: 'Temps plein',
  jobStatus_part_time: 'Temps partiel',
  jobStatus_per_diem: 'Par jour',
  jobStatus_not_specified: 'Non spécifié',
  en: 'English',
  is: 'Íslenska',
  pl: 'Polski',
  no: 'Norsk',
  sv: 'Svenska',
  fr: 'Français',
  languageSwitcher_title: 'Sélectionner la langue',
  'The submitted file is empty.': 'Le fichier soumis est vide.',
  job_does_not_exist_header: "La page que vous recherchez n'existe pas",
  job_does_not_exist_sub_header:
    "Vous avez peut-être mal tapé l'adresse ou le poste a été supprimé",
  job_does_not_exist_link: "Emmenez-moi à la page d'accueil",
  fiftyFooter_poweredBy: 'En partenariat avec',
  jobStatus_title: 'Statut du poste',
  cookie_consent_main_text: 'En utilisant le site, vous acceptez notre',
  cookie_consent_privacy_cta_text: 'politique de cookies.',
  cookie_consent_privacy_button_text: 'Rejeter',
  department_title_unknown: 'Non spécifié {0}',
  helpers_add: 'Ajouter un fichier',
};
